<template>
  <v-text-field
    :value="formattedValue"
    v-bind="$attrs"
    v-on="$listeners"
    @input="input"
    @keypress="keypress"
    @focus="focus"
    @blur="blur"
  />
</template>

<script>
import CurrencyInputMixin from '../../mixins/currency-input';

export default {
  mixins: [
    CurrencyInputMixin,
  ],

  props: {
    precision: { type: Number, default: 2 },
    prefix: { type: String, default: '$' },
  },
};
</script>
